import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { ExitViewModule } from '../../../shared/components/exit-view/exit-view.component.module';
import { ModalsModule } from './../../../shared/modals/modals.module';
import { SharedServicesModule } from './../../../shared/services/shared.services.module';
import { HistoryCard } from './history-card/history-card.component';
import { SsvSideNavPrimary } from './ssv-side-nav-primary.component';

@NgModule({
  declarations: [SsvSideNavPrimary, HistoryCard],
  imports: [
    CommonModule,
    SharedServicesModule,
    MatSidenavModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatCardModule,
    MatGridListModule,
    MatExpansionModule,
    ExitViewModule,
    ModalsModule,
  ],
  exports: [SsvSideNavPrimary, HistoryCard],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SsvSideNavPrimaryModule {}
